<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells_hd">基础信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <div class="weui-cell" slot="cu_name">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_name || "客户名称"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cu_name"
              placeholder="请填写"
            />
          </div>
        </div>
        <combo-field
          slot="cu_type"
          :label="customLabel.cu_name || '客户类型'"
          v-model="form.main.cu_type"
          url="/api/document/customerkind/getCombo"
        />
        <div class="weui-cell" slot="cu_bankaccount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_bankaccount || "开户银行"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cu_bankaccount"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="cu_bankcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_bankcode || "银行账号"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cu_bankcode"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="cu_invoiceinfo">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_invoiceinfo || "开票地址"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cu_invoiceinfo"
              placeholder="请填写"
            />
          </div>
        </div>
        <combo-field
          slot="cu_industry"
          :label="customLabel.cu_industry || '行业类型'"
          v-model="form.main.cu_industry"
          url="/api/document/industry/getCombo"
        />
        <combo-field
          slot="cu_source"
          :label="customLabel.cu_source || '商机线索'"
          v-model="form.main.cu_source"
          url="/api/document/genericoption/getCombo"
          :params="{bizType: caller, fieldName: 'cu_source'}"
        />
      </custom-layout>

      <div class="weui-cells_hd">交易信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <currency-field
          slot="cu_currency"
          :label="customLabel.cu_currency || '交易币别'"
          v-model="form.main.cu_currency"
          :use-default="true"
        />
        <div class="weui-cell" slot="cu_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_taxrate || "税率(%)"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cu_taxrate"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="cu_credit">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_credit || "信用额度"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cu_credit"
              placeholder="请填写"
            />
          </div>
        </div>
        <payment-field
          v-model="form.main.cu_payments"
          @select="onSelectPayment"
          slot="cu_payments"
          :label="customLabel.cu_payments || '收款方式'"
        />
        <div class="weui-cell" slot="cu_paydelay">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_paydelay || "收款延迟天数"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cu_paydelay"
              placeholder="请填写"
            />
          </div>
        </div>
        <payment-field
          v-model="form.main.cu_payments1"
          @select="onSelectPayment1"
          slot="cu_payments1"
          :label="customLabel.cu_payments1 || '收款方式1'"
        />
        <div class="weui-cell" slot="cu_paydelay1">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_paydelay1 || "收款延迟天数1"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cu_paydelay1"
              placeholder="请填写"
            />
          </div>
        </div>
        <payment-field
          v-model="form.main.cu_payments2"
          @select="onSelectPayment2"
          slot="cu_payments2"
          :label="customLabel.cu_payments2 || '收款方式2'"
        />
        <div class="weui-cell" slot="cu_paydelay2">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_paydelay2 || "收款延迟天数2"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.cu_paydelay2"
              placeholder="请填写"
            />
          </div>
        </div>
       
        <employee-field
          :label="customLabel.cu_sellername || '业务员'"
          v-model="form.main.cu_sellername"
          @select="onSelectEmployee"
          slot="cu_sellername"
        />
        <account-check-box  slot="cu_othersellers" :label="'其他业务员'" v-model="form.main.cu_othersellers" @select="onSelectCcrecipients2" />
        <div class="weui-cell" slot="cu_remark">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{
              customLabel.cu_remark || "变更原因"
            }}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.cu_remark"
              placeholder="请填写"
            />
          </div>
        </div>
        <custom-field 
          :label="customLabel.cu_text1 || '自定义字段1'"
          v-model="form.main.cu_text1" :caller="caller" fieldName="cu_text1"
          slot="cu_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.cu_text2 || '自定义字段2'"
          v-model="form.main.cu_text2" :caller="caller" fieldName="cu_text2"
          slot="cu_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.cu_text3 || '自定义字段3'"
          v-model="form.main.cu_text3" :caller="caller" fieldName="cu_text3"
          slot="cu_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.cu_text4 || '自定义字段4'"
          v-model="form.main.cu_text4" :caller="caller" fieldName="cu_text4"
          slot="cu_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.cu_text5 || '自定义字段5'"
          v-model="form.main.cu_text5" :caller="caller" fieldName="cu_text5"
          slot="cu_text5" hidden="true"
        />
      </custom-layout>
      <div class="weui-cells">
        <file-field v-model="form.main.cu_attach" ref="cu_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="save"
        >提交</a
      >
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
        >取消</a
      >
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ComboField from "@/components/field/ComboField.vue";
import FileField from "@/components/field/FileField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import PaymentField from "@/components/field/PaymentField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";
import AccountCheckBox from "@/components/field/AccountCheckBox.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    ComboField,
    FileField,
    CurrencyField,
    PaymentField,
    EmployeeField,
    CustomField,
    AccountCheckBox
  },
  data() {
    return {
      baseUrl: "/api/document/customer",
      codeField: "cu_code",
      statusField: "cu_audit_status_code",
      caller: "CustomerChange",
      xtype: "customer-change-formpanel",
      form: {
        main: {
          cu_taxrate: 0,
          cu_remark: ""
        }
      }
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main
      if (!main.cu_name) {
        me.$weui.topTips("请填写客户名称", 2000);
      } else if (!main.cu_bankaccount) {
        me.$weui.topTips("请填写开户银行", 2000);
      } else if (!main.cu_bankcode) {
        me.$weui.topTips("请填写银行账号", 2000);
      } else if (!main.cu_invoiceinfo) {
        me.$weui.topTips("请填写开票地址", 2000);
      } else if (!main.cu_currency) {
        me.$weui.topTips("请选择默认币种", 2000);
      } else if (!main.cu_payments) {
        me.$weui.topTips("请选择收款方式", 2000);
      } else if (typeof main.cu_taxrate === "undefined") {
        me.$weui.topTips("请填写税率", 2000);
      } else if (!main.cu_sellername) {
        me.$weui.topTips("请选择业务员", 2000);
      } else if (!main.cu_remark) {
        me.$weui.topTips("请填写变更原因", 2000);
      } else {
        me.p_save();
      }
    },
    onSelectPayment(selection) {
      var me = this,
        main = me.form.main;
      main.cu_paymentsid = selection.id;
      main.cu_paymentscode = selection.pa_code;
    },
    onSelectPayment1(selection) {
      var me = this,
        main = me.form.main;
      main.cu_paymentsid1 = selection.id;
      main.cu_paymentscode1 = selection.pa_code;
    },
    onSelectPayment2(selection) {
      var me = this,
        main = me.form.main;
      main.cu_paymentsid2 = selection.id;
      main.cu_paymentscode2 = selection.pa_code;
    },
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.cu_sellerid = selection.id;
      main.cu_sellercode = selection.em_code;
    },
    onSelectCcrecipients(selection) {
      let main = this.form.main;
      main.cu_brands = selection.map((item) => item.value).join(",");
    },
    onSelectCcrecipients2(selection) {
      let main = this.form.main
      main.cu_othersellers = selection.map(item => item.em_name).join(','),
      main.cu_othersellerids = selection.map(item => item.id).join(',')
    },
    p_save() {
      var me = this, jsonData = me.form.main, caller = me.caller, xtype = me.xtype
      me.$loading({
        method: "post",
        url: "/api/document/customer/modifyDetail",
        jsonData
      }).then(function (res) {
        if (res.success) {
          me.preLaunchProcess(caller, res.data.change, xtype,
          function () {
            me.p_router_to_read(res.data.id);
          });
        } else {
          me.$weui.topTips(res.message, 3000);
        }
      });
    }
  },
};
</script>